export default {
  SET_NOTIFICATION: 'SET_NOTIFICATION'
}
